export default __webpack_public_path__ + "static/e-commerce-header-ddb5e9e8c4de5d59d9a2d6258934788d.jpg";